import { Routes } from '@angular/router';
import { Component, Input, OnInit } from '@angular/core';

import { AtxRouterTabsService } from '../services/atx-router-tabs.service';

@Component({
    selector: 'atx-router-tabs',
    template: `<ul [class]="clazz">
    <li class="nav-item"
        routerLinkActive="active"
        [routerLink]="path + route?.path"
        *ngFor="let route of routes | filter: 'path':'**'">
        <a class="nav-link"
           routerLinkActive="active"
           [routerLink]="path + route?.path">
            {{ route?.path }}
        </a>
    </li>
</ul>

<ng-content></ng-content>
`,
})

export class AtxRouterTabsComponent implements OnInit {
    @Input() public path: string;
    @Input() public readonly clazz: string;
    @Input() public readonly routes: Routes;
    @Input() public readonly count: number = 3;

    constructor(private service: AtxRouterTabsService) {}

    public ngOnInit() {
        if (!this.path) {
            this.path = this.service.getPathname(this.count);
        }
    }
}
